export default __webpack_public_path__ + "static/media/money-back.ca900327.png";